.root {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--shape-full);
  overflow: hidden;
  background: var(--md-surface-container);
  color: var(--md-on-surface-variant);
  flex-shrink: 0;
}

.sm {
  width: 2rem;
  height: 2rem;
}

.md {
  width: 2.5rem;
  height: 2.5rem;
}

.lg {
  width: 3rem;
  height: 3rem;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.fallback {
  width: 60%;
  height: 60%;
}
